import styled, { css } from 'styled-components';

import { ReactComponent as WaveSVG } from 'Public/graphics/waves/hero-banner/staff/staff-hero-wave.svg';

import BaseLink from 'Elements/Link/Link';

export const Container = styled.div`
    position: relative;
    padding: 7rem 0 2rem;
    overflow: hidden;
`;

export const Heading = styled.h1`
    ${({ theme }) => css`
        font-size: 1.5rem;
        line-height: 1.4;
        margin: 0;

        @media ${theme.breakpoints.large.media} {
            font-size: 2.5rem;
        }
    `}
`;

export const JobTitle = styled.p`
    ${({ theme }) => css`
        margin: 0;
        font-size: 1rem;
        font-weight: 700;
        color: ${theme.colors.primary.hex};

        @media ${theme.breakpoints.large.media} {
            font-size: 2rem;
        }
    `}
`;

export const Department = styled.p`
    ${({ theme }) => css`
        font-family: ${theme.fonts.secondary};
        font-size: 1rem;
        font-weight: 300;
        margin: 0.75rem 0 0;

        @media ${theme.breakpoints.large.media} {
            font-size: 1.25rem;
            margin: 1rem 0 0;
        }
    `}
`;

export const InformationContainer = styled.div`
    ${({ theme }) => css`
        margin-top: 1rem;

        @media ${theme.breakpoints.large.media} {
            margin-top: 1.5rem;
        }
    `}
`;

export const ContactInformation = styled.div`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        margin-top: 0.5rem;

        @media ${theme.breakpoints.large.media} {
            margin-top: 1rem;
        }
    `}
`;

export const StyledIcon = styled.svg`
    color: ${({ theme }) => theme.colors.primary.hex};
    width: 1.25rem;
    height: 1.25rem;
    margin-right: 0.75rem;
`;

export const SocialIconsWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 1rem;

    @media ${({ theme }) => theme.breakpoints.medium.media} {
        justify-content: left;
        margin-top: 1.5rem;
        padding-bottom: 2rem;
    }
`;

export const Link = styled(BaseLink)`
    ${({ theme }) => css`
        font-size: 1rem;
        color: ${theme.colors.text.hex};

        @media ${theme.breakpoints.large.media} {
            font-size: 1.25rem;
        }
    `}
`;

export const ImageContainer = styled.div`
    ${({ theme }) => css`
        position: relative;
        height: 100%;

        @media ${theme.breakpoints.large.media} {
            display: grid;
            place-items: center;
        }
    `}
`;

export const ImageWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        margin: 0 auto;
        width: 6rem;
        height: 6rem;
        border-radius: 50%;
        border: 0.5rem solid ${theme.colors.primary.hex};
        box-sizing: content-box;
        background: ${theme.colors.secondary.hex};
        overflow: hidden;

        @media ${theme.breakpoints.large.media} {
            width: 11rem;
            height: 11rem;
        }
    `}
`;

export const Wave = styled(WaveSVG)`
    ${({ theme }) => css`
        position: absolute;
        z-index: -1;
        top: -20rem;
        right: -18rem;
        width: 57rem;
        height: 85rem;

        @media ${theme.breakpoints.smallLarge.media} {
            top: -21rem;
            right: -13rem;
        }

        @media ${theme.breakpoints.medium.media} {
            top: -20rem;
            right: -5rem;
        }

        @media ${theme.breakpoints.large.media} {
            top: -29rem;
            right: -10rem;
            width: 85rem;
            height: 128rem;
        }
    `}
`;
